"use strict";
/**
 * Created on 12 06 2019
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var ValidationLevel_1 = require("../../../../core/model/data-dictionary/ValidationLevel");

var ValidationResult_1 = require("../../../../core/model/data-dictionary/ValidationResult");

var Validator_1 = require("../../../../core/model/data-dictionary/Validator");
/**
 * <p>Validator of {@link SelloutRelease.minMarginChangeInPercent}</p>
 *
 * <p>Min margin change in percent cannot be greater or equal to 100 percent.</p>
 *
 * @author JMe
 */


var SelloutReleaseMinMarginChangeValidator =
/*#__PURE__*/
function (_Validator_1$Validato) {
  _inherits(SelloutReleaseMinMarginChangeValidator, _Validator_1$Validato);

  function SelloutReleaseMinMarginChangeValidator() {
    _classCallCheck(this, SelloutReleaseMinMarginChangeValidator);

    return _possibleConstructorReturn(this, _getPrototypeOf(SelloutReleaseMinMarginChangeValidator).call(this, ValidationLevel_1.ValidationLevel.Fast));
  }

  _createClass(SelloutReleaseMinMarginChangeValidator, [{
    key: "doValidate",
    value: function doValidate(value) {
      if (value > 100) {
        return new ValidationResult_1.ValidationError('Cannot be greater or equal to 100 percent!');
      }

      return new ValidationResult_1.ValidationSuccess(value);
    }
  }]);

  return SelloutReleaseMinMarginChangeValidator;
}(Validator_1.Validator);

exports.SelloutReleaseMinMarginChangeValidator = SelloutReleaseMinMarginChangeValidator;